import auth0 from 'auth0-js';
import Config from 'app/config';

const LOGIN_STATE_KEY = 'LoginState';
const LOGIN_NONCE_KEY = 'LoginNonce';
const LOGIN_REDIRECT = 'LoginRedirect';

export const isEnabled = true;

const getRandomNumber = () => {
  const crypto = window.crypto || window.msCrypto;
  return crypto.getRandomValues(new Uint32Array(10))[0];
};

const getAuth0ValidationValue = localStorageKey => {
  let value = window.localStorage.getItem(localStorageKey);
  if (!value) {
    value = getRandomNumber();
    window.localStorage.setItem(localStorageKey, value);
  }
  return value;
};

const clearState = () => window.localStorage.removeItem(LOGIN_STATE_KEY);
const clearNonce = () => window.localStorage.removeItem(LOGIN_NONCE_KEY);
const clearRedirect = () => window.localStorage.removeItem(LOGIN_REDIRECT);

export const scope = 'openid profile email';
export const getAudience = () => Config.get('AUTH0_AUDIENCE');
export const getDomain = () => Config.get('AUTH0_DOMAIN');
export const getState = () => getAuth0ValidationValue(LOGIN_STATE_KEY);
export const getNonce = () => getAuth0ValidationValue(LOGIN_NONCE_KEY);

let auth0WebAuth;

export const getAuth0 = () => {
  if (!auth0WebAuth) {
    auth0WebAuth = new auth0.WebAuth({
      domain: getDomain(),
      clientID: Config.get('AUTH0_CLIENT_ID'),
      redirectUri: `${window.location.origin}`,
      responseType: 'token id_token',
      scope,
      audience: getAudience(),
    });
  }

  return auth0WebAuth;
};

export const getLoginUrl = redirectPath => {
  const accountHost = Config.get('ACCOUNT_HOST');
  const callbackUrl = `${window.location.origin}/sign`;
  const redirectUrl = `${window.location.origin}/${redirectPath}`;

  window.localStorage.setItem(LOGIN_REDIRECT, redirectUrl);

  return `${accountHost}/login?signUrl=${callbackUrl}&callbackUrl=${callbackUrl}&auth0=${isEnabled}&domain=${getDomain()}&audience=${getAudience()}&scope=${scope}&state=${getState()}&nonce=${getNonce()}`;
};

export const parseSession = (authResult, redirect) =>
  new Promise((resolve, reject) => {
    if (authResult && authResult.accessToken && authResult.idToken) {
      const expires = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
      return getAuth0().client.userInfo(authResult.accessToken, (error, user) => {
        if (error) {
          return reject(error);
        }
        return resolve({
          expires,
          token: authResult.accessToken,
          idToken: authResult.idToken,
          isAuth0: true,
          userId: user.sub,
          redirect,
        });
      });
    }
    return resolve(null);
  });

export const parseHash = () =>
  new Promise((resolve, reject) => {
    getAuth0().parseHash({ state: getState(), nonce: getNonce() }, (parseError, authResult) => {
      if (parseError) {
        return reject(parseError);
      }
      const redirect = window.localStorage.getItem(LOGIN_REDIRECT);
      clearRedirect();
      clearState();
      clearNonce();
      return parseSession(authResult, redirect)
        .then(resolve)
        .catch(reject);
    });
  });

export const checkSession = (onSuccess, onError) => {
  getAuth0().checkSession({ responseType: 'token id_token' }, (error, result) => {
    if (error) {
      onError();
    } else {
      this.parseSession(result)
        .then(onSuccess)
        .catch(onError);
    }
  });
};

export const logout = () => {
  getAuth0().logout({
    returnTo: `${window.location.origin}`,
    clientID: Config.get('AUTH0_CLIENT_ID'),
  });
};

export const fetchUser = token => {
  return new Promise((resolve, reject) => {
    getAuth0().client.userInfo(token, (error, user) => {
      if (error) {
        return reject(error);
      }
      return resolve(user);
    });
  });
};
